import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import CommonTooltip from '../../../../../../../../../component/common/CommonTooltip';

const AssociateListTable = (props) => {
    const {
        index,
        select_association,
        add_example,
        action_name,
        select_response_type,
        folow_up_details
    } = props;

    let associationHtml = '';
    if(select_association.length > 0){
        associationHtml = select_association.map((associate, i) => (
            <span className="fs-7 fw-bold me-2 text-gray-600"  key={i}>
                <span className="text-gray-600 fw-bold fs-6">
                    {associate.value}
                </span>
            </span>
        ))
    }

    const associationDataDeleteOnClick = async (index) => {
        const associateDeleteSwal = await Swal.fire({
            title: 'Are you sure?',
            text: 'You won’t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        });
        if (associateDeleteSwal.isConfirmed) {
            props.associationDataDelete(index)
        }
    }

    const handleDragStart = (e) => {
        e.dataTransfer.setData('text/plain', index);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const draggedIndex = parseInt(e.dataTransfer.getData('text/plain'), 10);
        props.onDragDrop(draggedIndex, index);
    };
    
    return(
        <>
            <tr
                draggable
                onDragStart={handleDragStart}
                onDragOver={(e) => e.preventDefault()}
                onDrop={handleDrop}
                style={{
                    cursor: "move",
                }}
            >
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    {associationHtml}
                </td>
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    {add_example}
                </td>
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    {action_name}
                </td>
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    {select_response_type ? select_response_type.label: ''}
                </td>
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    {folow_up_details ? folow_up_details.label: ''}
                </td>
                <td className="d-flex float-end" >
                    <div
                        className='cursor-pointer me-3' 
                        onClick={(e) => { e.preventDefault(); props.associationDataUpdateOnClick(index) }} 
                        data-tooltip-id="common_tooltip" 
                        data-tooltip-content="Edit"
                    >
                        <FontAwesomeIcon icon={faPen} className='text-primary fs-3' />
                    </div>
                    <div
                        className='cursor-pointer'
                        onClick={(e) => { e.preventDefault(); associationDataDeleteOnClick(index)}}
                        data-tooltip-id="common_tooltip" 
                        data-tooltip-content="Delete"
                    >
                        <FontAwesomeIcon icon={faTrash} className='text-danger fs-3' />
                    </div>
                </td>
            </tr>
            <CommonTooltip
                id="common_tooltip"
                style= {{ backgroundColor: "black", color: "white", fontSize:"14px" }}
                place="top"
                float={true}
            />
        </>
    )
}

const ProductFeatureAssociationSetupList = (props) => {
    const { associatedDataList } = props;

    const [ totalDataList , setTotalDataList ] = useState([])

    useEffect(() => {
        if (associatedDataList) {
            setTotalDataList(associatedDataList);
        }
    }, [associatedDataList]);

    const onDragDropHandler = (draggedIndex, targetIndex) => {
        const updatedList = [...totalDataList];
        const [draggedItem] = updatedList.splice(draggedIndex, 1);
        updatedList.splice(targetIndex, 0, draggedItem);
        updatedList.forEach((item, newIndex) => {
            item.index = newIndex;
        });
        setTotalDataList(updatedList);
        props.associateListOnDrop(updatedList)
    }

    let associateHtml = ``;
    if( totalDataList.length > 0 ){
        associateHtml = totalDataList.map((associate, i) => (
            <AssociateListTable
                key={i}
                index={i}
                select_association={associate.select_association}
                add_example={associate.add_example}
                action_name={associate.action_name}
                select_response_type={associate.select_response_type}
                folow_up_details={associate.folow_up_details}
                associationDataUpdateOnClick={props.associationDataUpdate}
                associationDataDelete={props.associationDataDelete}
                onDragDrop={onDragDropHandler}
            />
        ))
    }

    return (
        <>
            {
                totalDataList.length > 0 &&
                <>
                    <div className="separator border-gray-300 my-6"></div>
                    <div className="table-responsive">
                        <table className="table table-row-dashed align-middle gs-0 gy-4">
                            <thead className="border-gray-200 fs-5 fw-semibold bg-lighten">
                                <tr className='fs-7 fw-bold border-0 text-gray-400'>
                                    <th className="" style={{width: '250px'}}>Selected Association</th>
                                    <th className="">Example</th>
                                    <th className="">Sub Action</th>
                                    <th className="">Response Type</th>
                                    <th className="">Follow Up</th>
                                    <th className=""></th>
                                </tr>
                            </thead>
                            <tbody className="fw-6 fw-semibold text-gray-600">
                                {associateHtml}
                            </tbody>
                        </table>
                    </div>
                </>
            }
        </>
    )
}

export default ProductFeatureAssociationSetupList